'use client';

import React, { useState, useEffect } from "react";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import ImageComponent from "./ImageComponent";

const CarouselCard = ({ media, autoSlide = true, slideInterval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slideDirection, setSlideDirection] = useState("");

  const handlePrev = () => {
    setSlideDirection("prev");
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? media.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setSlideDirection("next");
    setCurrentIndex((prevIndex) =>
      prevIndex === media.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Auto-slide functionality
  useEffect(() => {
    if (autoSlide && media.length > 1) {
      const intervalId = setInterval(handleNext, slideInterval);
      return () => clearInterval(intervalId); // Cleanup interval on unmount
    }
  }, [autoSlide, slideInterval, media.length]);

  useEffect(() => {
    if (slideDirection) {
      const timeoutId = setTimeout(() => {
        setSlideDirection(""); // Reset direction after slide transition
      }, 500); // Duration of the transition
      return () => clearTimeout(timeoutId);
    }
  }, [currentIndex]);

  if (!media || media.length === 0) {
    return <div>No media available</div>;
  }

  const showControls = media.length > 1;
  const showIndicators = media.length > 1;

  return (
    <div className="carousel-card">
      <div className="carousel-guard">
        <div
          className="carousel-background"
          style={{
            backgroundImage: `url(${media[currentIndex].mediaThumb})`,
          }}
        ></div>
        <div className="carousel-slide">
          <div
            className="slide-section"
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
              transition: "transform 0.5s ease-in-out",
            }}
          >
            {media.map((item, index) => (
              <div key={index} className="slide-item">
                <div className="carousel-image-wrapper">
                  <ImageComponent
                    src={item.mediaThumb.replace("r200x200", "r1500x1500")}
                    alt={`Slide ${index + 1}`}
                    className={`carousel-image ${
                      slideDirection === "prev" ? "prev-slide" : "next-slide"
                    }`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        {showControls && (
          <>
            <AiOutlineArrowLeft
              className="carousel-button prev"
              onClick={handlePrev}
            />
            <AiOutlineArrowRight
              className="carousel-button next"
              onClick={handleNext}
            />
          </>
        )}
      </div>
      {showIndicators && (
        <div className="carousel-indicators">
          {media.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      )}
    </div>
  );
};

export default CarouselCard;
